// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"eN-z","carouselContainer":"fN-z"};